import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';

// Own constants/actions/components
import { AMEX_LINK, SANTANDER_LINK } from 'constants/Constants';
import cobrandAmex from 'assets/cobrand-AMEX.svg';
import cobrandSantander from 'assets/cobrand-Santander.svg';
import cartMini from 'assets/cart-mini.svg';

const ExclusivitiesAmexSantander = ({ resetShoppingCart }) => {
  const history = useHistory();

  const removeExp = () => {
    resetShoppingCart();
    history.push('/');
  };

  return (
    <>
      <Col lg={9} className="text-center">
        <h2>¡Lo sentimos, no se pudo completar el pedido!</h2>
        <h3 className="pt-30 pb-15 text-tangaroa">
          Las Experiencias que intentaste adquirir son exclusivas de Tarjetahabientes.
        </h3>
        <Row className="justify-content-center">
          <Col xs={12} lg={5}>
            <div className="card p-15 my-15 card-exclusivity bg-color-alabaster">
              <img src={cobrandAmex} alt="shopping-cart-cobrand-amex" />
              <h4 className="py-15 text-secondary">
                Si deseas adquirir la Tarjeta American Express® Aeroméxico da
                {' '}
                <a href={AMEX_LINK}>click aquí.</a>
              </h4>
            </div>
          </Col>
          <Col xs={12} lg={5}>
            <div className="card p-15 my-15 card-exclusivity bg-color-alabaster">
              <img src={cobrandSantander} alt="shopping-cart-cobrand-santander" />
              <h4 className="py-15 text-secondary">
                Si deseas adquirir la Tarjeta Santander Aeroméxico da
                {' '}
                <a href={SANTANDER_LINK}>click aquí.</a>
              </h4>
            </div>
          </Col>
        </Row>
        <h3 className="py-30 text-boulder-light">
          Haz clic en el botón de ‘Navegar’ para buscar más Experiencias.
        </h3>
        <button type="button" className="btn btn-primary" onClick={removeExp}>
          Navegar
        </button>
      </Col>
      <Col lg={3}>
        <div className="bg-color-alabaster p-15 mt-30 mt-lg-0">
          <div className="overlap-gray">
            <img src={cartMini} alt="shopping-cart-icon" className="py-15" />
            <h3>Resumen de tu pedido</h3>
            <p>Aún no tienes seleccionado ningún campo</p>
          </div>
        </div>
      </Col>
    </>
  );
};

ExclusivitiesAmexSantander.propTypes = {
  resetShoppingCart: PropTypes.func.isRequired,
};

export default ExclusivitiesAmexSantander;
